import { mkBillerAccount } from './billerAccountsTypes';

export const transformResponseToBillerAccounts = (response) =>
  response.data.resources.map((data) => mkBillerAccount({ ...data }));
